// extracted by mini-css-extract-plugin
module.exports = {"charts":"_1ilARE","chart":"g0pPNf","themeSwitcher":"_39niDQ","themeSwitcherHolder":"jTECPP","button":"_1txMRQ","buttonsBlock":"_3-6ytr"};